import { fromJS } from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { addItemToArray, deleteItemFromArray, returnStateIfNoAction } from '../helpers';


const getInitState = weeks => {
    return fromJS({
        key: uuidv4(),
        status: requestStatus.INITIALIZED,
        form: {
            title: '',
            body: '',
            link: {
                url: '',
                destinationType: 'internal',
            },
        },
        attachedItem: null,
        error: null,
        weeks: weeks,
        currentWeek: weeks[1],
    })
}

const onCreateRequest = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

// Formular und Attachment bleiben nach dem Senden in JEDEM Modus erhalten:
// Multi-Standort-Kinos passen dieselbe Nachricht je Standort leicht an und
// senden erneut. Der frühere Reset im Default-Modus warf Attachment und
// Eingaben nach dem Absenden weg.
const onCreateRequestSuccess = (state, action) => state.set('status', requestStatus.REQUEST_SUCCESS)
                                                       .set('error', '')

const onError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR)
                                        .setIn(['error'], action.payload.errorMessage)

const updateAttachedItem = (state, action) => {
    const { itemData} = action.payload


    return state.setIn(['attachedItem'], itemData)
}

const updateForm = (state, action) => {
    const { itemData} = action.payload
    return state.setIn(['form'], itemData)
}

const pushCreateReducer = weeks => (state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PUSH_CREATE_ATTACHED_ITEM_UPDATE:
            return updateAttachedItem(state, action).set('hasChanges', true);
        case actionTypes.PUSH_CREATE_FORM_UPDATE:
            return updateForm(state, action).set('hasChanges', true);
        case actionTypes.PUSH_CREATE_REQUEST:
            return onCreateRequest(state, action)                          
        case actionTypes.PUSH_CREATE_REQUEST_SUCCESS:
            return onCreateRequestSuccess(state, action)      
        case actionTypes.PUSH_CREATE_REQUEST_ERROR:
            return onError(state, action)                          
        default:
            return state;
    }
}


export default pushCreateReducer;
